import { ITEM_AVAILABILITY_STATUS } from 'features/Sku/Items/SkuItems.constants';

import { namedOptions, toGroupFields, visibleModifiers } from './Modifiers.formState';
import { NONE_VALUE } from './RulesBlock';

const MIN_SELECTION_FIELD = 'rules.minSelection';
const REQUIRED_FIELD = 'rules.isRequired';

export const RULE_ERROR_FIELDS = [MIN_SELECTION_FIELD, REQUIRED_FIELD];

const isNoneSelection = value => value === NONE_VALUE || value === '' || value == null;

export const ruleErrorField = values => {
  const rules = values?.rules || {};
  return rules.allowsMultiple && !isNoneSelection(rules.minSelection) ? MIN_SELECTION_FIELD : REQUIRED_FIELD;
};

export const ruleInputSignature = values =>
  JSON.stringify([values?.rules, (values?.modifiers || []).map(option => option.availabilityStatus)]);

export const unsatisfiableRule = values => {
  const { allowsQuantities, selectionsMin } = toGroupFields(values);
  if (allowsQuantities || !selectionsMin || selectionsMin < 1) return false;

  const availableCount = namedOptions(values).filter(
    option => option.availabilityStatus === ITEM_AVAILABILITY_STATUS.AVAILABLE
  ).length;

  return availableCount < selectionsMin;
};

export const deleteWouldBreakRule = (values, index) => {
  const option = (values.modifiers || [])[index];
  const isCountedOption =
    namedOptions(values).includes(option) && option?.availabilityStatus === ITEM_AVAILABILITY_STATUS.AVAILABLE;
  if (!isCountedOption) return false;

  return unsatisfiableRule({ ...values, modifiers: values.modifiers.filter((_, position) => position !== index) });
};

const storedDefaultId = loadedGroup =>
  visibleModifiers(loadedGroup).find(modifier => modifier.core?.isDefault)?.core?.id || '';

const formDefaultId = values => (values.rules?.hasDefault && values.rules?.defaultOptionId) || '';

export const sharedEditNeedsConfirm = (loadedGroup, values) => {
  if (!loadedGroup || (loadedGroup.attachedItems || []).length === 0) return false;

  const compiled = toGroupFields(values);
  const stored = loadedGroup.core || {};

  return (
    compiled.name !== stored.name ||
    compiled.selectionsMin !== stored.selectionsMin ||
    compiled.selectionsMax !== stored.selectionsMax ||
    compiled.allowsQuantities !== Boolean(stored.allowsQuantities) ||
    formDefaultId(values) !== storedDefaultId(loadedGroup)
  );
};
